import React from "react";
import { Form } from "react-bootstrap";
import { ErrorMessage } from "formik";

export default function DoctorTabFields({ values, handleChange }) {
  return (
    <>
      <div className="d-flex flex-wrap">
        <div className="mb-3 me-lg-3 me-0 flex-grow-1">
          <Form.Label>Doctor's Name/Pratice Name</Form.Label>
          <Form.Control
            type="text"
            name="doctorName"
            placeholder="Enter name"
            value={values.doctorName}
            onChange={handleChange}
          />
          <ErrorMessage
            name="doctorName"
            component="p"
            className="error-message"
          />
        </div>
        <div className="mb-3 flex-grow-1">
          <Form.Label>Address Line 1</Form.Label>
          <Form.Control
            type="text"
            name="doctorAddress1"
            placeholder="Enter address"
            value={values.doctorAddress1}
            onChange={handleChange}
          />
          <ErrorMessage
            name="doctorAddress1"
            component="p"
            className="error-message"
          />
        </div>
      </div>
      <div className="d-flex flex-wrap">
        <div className="mb-3 me-lg-3 me-0 flex-grow-1">
          <Form.Label>Address Line 2</Form.Label>
          <Form.Control
            type="text"
            name="doctorAddress2"
            placeholder="Enter address"
            value={values.doctorAddress2}
            onChange={handleChange}
          />
          <ErrorMessage
            name="doctorAddress2"
            component="p"
            className="error-message"
          />
        </div>
        <div className="mb-3 flex-grow-1">
          <Form.Label>City</Form.Label>
          <Form.Control
            type="text"
            name="doctorCity"
            placeholder="Enter city"
            value={values.doctorCity}
            onChange={handleChange}
          />
          <ErrorMessage
            name="doctorCity"
            component="p"
            className="error-message"
          />
        </div>
      </div>
      <div className="d-flex flex-wrap">
        <div className="mb-3 me-lg-3 me-0 flex-grow-1">
          <Form.Label>Postcode</Form.Label>
          <Form.Control
            type="text"
            name="doctorPostcode"
            placeholder="Enter postcode"
            value={values.doctorPostcode}
            onChange={handleChange}
          />
          <ErrorMessage
            name="doctorPostcode"
            component="p"
            className="error-message"
          />
        </div>
        <div className="mb-3 flex-grow-1">
          <Form.Label>Phone</Form.Label>
          <Form.Control
            type="tel"
            name="doctorPhone"
            placeholder="Enter phone number"
            value={values.doctorPhone}
            onChange={handleChange}
          />
          <ErrorMessage
            name="doctorPhone"
            component="p"
            className="error-message"
          />
        </div>
      </div>
    </>
  );
}
